/**
 * ตัวสุ่มแบบมี seed — สถานะเป็นเลข 32 บิตตัวเดียว เก็บลง GameState แล้ว
 * ส่งข้ามเน็ตเป็น JSON ได้ และเล่นย้อนหลังได้ผลเดิมเป๊ะ
 *
 * ใช้ splitmix32 แทน LCG ธรรมดา เพราะ LCG มีจุดอ่อนที่วัดได้จริง:
 * seed ที่ห่างกันไม่กี่หน่วย (เช่นเปิดเกมใหม่ห่างกันไม่กี่มิลลิวินาที)
 * จะให้ผลลัพธ์แรก ๆ เกาะกลุ่มกัน วัดได้ว่าแต้มเต๋าตาแรกเบ้ถึง 17.2% ต่อ 15.6%
 * splitmix32 คลุกบิตด้วย xor-shift + คูณสองรอบ seed ต่างกัน 1 ก็ให้ผลคนละทางทันที
 */
export interface Seeded {
  seed: number
}

const GOLDEN = 0x9e3779b9

export function rand(g: Seeded): number {
  g.seed = (g.seed + GOLDEN) | 0
  let t = g.seed
  t = Math.imul(t ^ (t >>> 16), 0x21f0aaad)
  t = Math.imul(t ^ (t >>> 15), 0x735a2d97)
  t = t ^ (t >>> 15)
  return (t >>> 0) / 4294967296
}

/** จำนวนเต็มใน [min, max] */
export function randInt(g: Seeded, min: number, max: number): number {
  return min + Math.floor(rand(g) * (max - min + 1))
}

export function shuffle<T>(g: Seeded, arr: readonly T[]): T[] {
  const out = arr.slice()
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(rand(g) * (i + 1))
    ;[out[i], out[j]] = [out[j], out[i]]
  }
  return out
}

export function pick<T>(g: Seeded, arr: readonly T[]): T {
  return arr[Math.floor(rand(g) * arr.length)]
}

/** สร้างตัวสุ่มอิสระจาก seed ก้อนเดียว ใช้ฝั่งกราฟิกที่ไม่ควรไปกวนลำดับสุ่มของเกม */
export function makeRng(seed: number): () => number {
  const g: Seeded = { seed: seed | 0 }
  return () => rand(g)
}
